export enum CurrencyType {
    COIN = 'COIN',
    TOKEN = 'TOKEN'
}
